import { type Action, createAction, createSlice } from '@reduxjs/toolkit';

import {
  ERequestFailedReason,
  type IRequestFailedAction,
  type IRequestFailedPayload,
  type IRequestFailedState,
  type IRequestTimeoutReportPayload,
} from './types';

export const requestFailed = createAction<IRequestFailedPayload>(
  'Socket/requestFailed',
);

export const requestTimeoutReport = createAction<IRequestTimeoutReportPayload>(
  'Socket/requestTimeoutReport',
);

export const isRequestFailed = (
  action: Action,
): action is IRequestFailedAction => requestFailed.match(action);

export const requestFailedMatcher =
  (sliceName: string) =>
  (action: Action): action is IRequestFailedAction =>
    isRequestFailed(action) &&
    action.payload.requestType.startsWith(`${sliceName}/`);

export const resetLoadingOnRequestFailed = (state: {
  isLoading: boolean;
}): void => {
  state.isLoading = false;
};

const initialState: IRequestFailedState = {
  visible: false,
  reason: null,
};

const requestFailedSlice = createSlice({
  name: 'RequestFailed',
  initialState,
  reducers: {
    hide: (state): void => {
      state.visible = false;
      state.reason = null;
    },
  },
  extraReducers: (builder): void => {
    builder.addCase(requestFailed, (state, action): void => {
      if (action.payload.reason === ERequestFailedReason.SearchUnavailable) {
        return;
      }

      state.visible = true;
      state.reason = action.payload.reason;
    });
  },
});

export const { hide } = requestFailedSlice.actions;

export default requestFailedSlice.reducer;
